export default "__VITE_ASSET__60d7649b__"